import { useEffect, useState } from "react";
import { Button, Modal, Form, message } from "antd";
import postDataTrace from "../../../../services/postDataTrace";

export default function UpdateStatus({
  selected,
  isVisible,
  setVisible,
  refetch,
}: any) {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();

  const { isActive } = selected;

  const onSubmit = async () => {
    setLoading(true);
    if (selected?.accessLevel === 9) {
      message.error("Super Admin Must Be Active");
      setVisible(false);
      setLoading(false);
      return;
    }
    const uri = `users/${selected?._id}/status`;
    const data = { isActive: !selected?.isActive };
    const response = await postDataTrace(data, uri);
    if (response.success) {
      const msg = data?.isActive ? "Account activated" : "Account deactivated";
      message.success(msg);
      refetch();
    }
    setVisible(false);
    setLoading(false);
  };

  const hideModal = async () => {
    setVisible(false);
  };
  useEffect(() => {}, [selected]);

  return (
    <Modal
      visible={isVisible}
      title={isActive ? `Deactivate User` : "Activate User"}
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          No
        </Button>,
        <Button
          key="submit"
          form="UpdateStatus"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Yes
        </Button>,
      ]}
    >
      <Form id="UpdateStatus" form={form} onFinish={onSubmit}>
        <div>
          <p className="text-center">
            Are you sure you want to
            {isActive ? (
              <span className="font-bold text-red-600 mx-1">Deactivate</span>
            ) : (
              <span className="font-bold text-green-600 mx-1">Activate</span>
            )}
            account for{" "}
            <p className="ml-1 font-bold mt-4">
              {selected?.firstname} {selected?.lastname}
            </p>
          </p>
        </div>
      </Form>
    </Modal>
  );
}
